function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var GameTemplate = require('../../lib/templates/gametemplate');
var Engine = require('./lib/engine');
var Map = require('./lib/map');
var Options = require('./lib/game-options.template');

/** Saito owns transport, persistence and encrypted cards; Engine owns the rules. */
var Conquest = /*#__PURE__*/function (_GameTemplate) {
  function Conquest(app) {
    var _this;
    _classCallCheck(this, Conquest);
    _this = _callSuper(this, Conquest, [app]);
    _this.name = 'Conquest';
    _this.slug = 'conquest';
    _this.gamename = 'Conquest';
    _this.title = 'Conquest · An atlas of ambition';
    _this.description = 'A brush-painted world of strategy. Classic world conquest for two to six players, with automatic bookkeeping and animated battles.';
    _this.categories = 'Games Boardgame Strategy';
    _this.status = 'alpha';
    _this["class"] = 'app';
    _this.minPlayers = 2;
    _this.maxPlayers = 6;
    _this.game_length = 90;
    _this.icon = 'fa-solid fa-earth-americas';
    _this.styles.push('/conquest/style.css');
    _this.confirm_moves = 0;
    _this.can_play_async = 0;
    _this.insert_rankings = true;
    _this.conquestUI = null;
    _this.conquestSending = false;
    _this.conquestError = '';
    _this.responseSent = new Set();
    return _this;
  }
  _inherits(Conquest, _GameTemplate);
  return _createClass(Conquest, [{
    key: "returnGameOptionsHTML",
    value: function returnGameOptionsHTML() {
      return Options();
    }
  }, {
    key: "returnAdvancedOptions",
    value: function returnAdvancedOptions() {
      return Options();
    }
  }, {
    key: "returnImage",
    value: function returnImage() {
      return '/conquest/img/cover.svg';
    }
  }, {
    key: "returnBanner",
    value: function returnBanner() {
      return '/conquest/img/cover.svg';
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var _this2 = this;
        var _loop, _i, _arr;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (this.browser_active) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              if (document.getElementById('conquest-root')) {
                _context2.n = 2;
                break;
              }
              _context2.n = 2;
              return this.injectGameHTML('<main id="conquest-root" aria-label="Conquest game"></main>');
            case 2:
              _context2.n = 3;
              return _superPropGet(Conquest, "render", this, 3)([app]);
            case 3:
              document.getElementById('conquest-root').classList.add('conquest-saito');
              this.menu.addMenuOption('game-game', 'Game');
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var _arr$_i, id, text, show;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      _arr$_i = _slicedToArray(_arr[_i], 3), id = _arr$_i[0], text = _arr$_i[1], show = _arr$_i[2];
                      _this2.menu.addSubMenuOption('game-game', {
                        id: id,
                        text: text,
                        callback: function callback() {
                          _this2.menu.hideSubMenus();
                          show();
                        }
                      });
                    case 1:
                      return _context.a(2);
                  }
                }, _loop);
              });
              _i = 0, _arr = [['conquest-rules', 'Field guide', function () {
                var _this2$conquestUI;
                return (_this2$conquestUI = _this2.conquestUI) === null || _this2$conquestUI === void 0 ? void 0 : _this2$conquestUI.rules();
              }], ['conquest-cards', 'Your cards', function () {
                var _this2$conquestUI2;
                return (_this2$conquestUI2 = _this2.conquestUI) === null || _this2$conquestUI2 === void 0 ? void 0 : _this2$conquestUI2.cards();
              }], ['conquest-stats', 'Stats', function () {
                var _this2$conquestUI3;
                return (_this2$conquestUI3 = _this2.conquestUI) === null || _this2$conquestUI3 === void 0 ? void 0 : _this2$conquestUI3.statistics();
              }], ['conquest-dispatches', 'Dispatches', function () {
                return _this2.log.toggleLog();
              }]];
            case 4:
              if (!(_i < _arr.length)) {
                _context2.n = 6;
                break;
              }
              return _context2.d(_regeneratorValues(_loop()), 5);
            case 5:
              _i++;
              _context2.n = 4;
              break;
            case 6:
              this.menu.addChatMenu();
              this.menu.render();
              window.ConquestMap = Map;
              window.ConquestEngine = Engine;
              // The generic script loader does not guarantee dependency order.
              if (window.THREE) {
                _context2.n = 7;
                break;
              }
              _context2.n = 7;
              return this.attachScript('/conquest/js/vendor/three.min.js');
            case 7:
              if (window.ConquestScene) {
                _context2.n = 8;
                break;
              }
              _context2.n = 8;
              return this.attachScript('/conquest/js/scene.js');
            case 8:
              if (window.ConquestStatisticsTemplate) {
                _context2.n = 9;
                break;
              }
              _context2.n = 9;
              return this.attachScript('/conquest/js/statistics.template.js');
            case 9:
              if (window.ConquestUI) {
                _context2.n = 10;
                break;
              }
              _context2.n = 10;
              return this.attachScript('/conquest/js/ui.js');
            case 10:
              this.mountConquest();
            case 11:
              return _context2.a(2);
          }
        }, _callee, this);
      }));
      function render(_x) {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "mountConquest",
    value: function mountConquest() {
      var _this3 = this;
      if (!this.browser_active || typeof window === 'undefined' || !window.ConquestUI || !this.game.state) return;
      var root = document.getElementById('conquest-root');
      if (!root) return;
      if (!this.conquestUI || this.conquestUI.element !== root) {
        var _this$conquestUI;
        (_this$conquestUI = this.conquestUI) === null || _this$conquestUI === void 0 || _this$conquestUI.destroy();
        // Reuse the header control; Conquest binds it to its clipped map viewport.
        this.sizer.render();
        this.conquestUI = new window.ConquestUI(root, {
          hasGameMenu: true,
          boardSizer: document.getElementById('game_board_sizer'),
          getState: function getState() {
            return _this3.viewState();
          },
          getPlayer: function getPlayer() {
            return _this3.game.player || -1;
          },
          getPlayerName: function getPlayerName(id) {
            return _this3.playerName(id);
          },
          getPlayerIdenticon: function getPlayerIdenticon(id) {
            return _this3.app.keychain.returnIdenticon(_this3.game.players[id - 1]);
          },
          showDispatches: function showDispatches() {
            return _this3.log.toggleLog();
          },
          getStatus: function getStatus() {
            return _this3.conquestStatus();
          },
          dispatch: function dispatch(action) {
            return _this3.submitAction(action);
          }
        });
      }
      this.conquestUI.render();
      document.body.style.setProperty('--conquest-active', "var(--conquest-player-".concat(this.game.state.currentPlayer, ")"));
      // The engine journal is public and chronological; GameLog displays newest first.
      this.log.logs = _toConsumableArray(this.game.state.log || []).reverse();
      this.log.render();
    }
  }, {
    key: "playerName",
    value: function playerName(id) {
      var _this$app$keychain;
      if (!id) return 'Neutral';
      var key = this.game.players[id - 1];
      return ((_this$app$keychain = this.app.keychain) === null || _this$app$keychain === void 0 ? void 0 : _this$app$keychain.returnUsername(key)) || "Player ".concat(id);
    }
  }, {
    key: "viewState",
    value: function viewState() {
      var state = JSON.parse(JSON.stringify(this.game.state));
      var _iterator = _createForOfIteratorHelper(state.players),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _this$game$deck;
          var player = _step.value;
          player.cards = player.id === this.game.player ? _toConsumableArray(((_this$game$deck = this.game.deck) === null || _this$game$deck === void 0 || (_this$game$deck = _this$game$deck[0]) === null || _this$game$deck === void 0 ? void 0 : _this$game$deck.hand) || []) : [];
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      state.networkBusy = this.conquestSending || !!this.game.conquestRandom || !!state.cardDraw || !!state.cardTransfer;
      return state;
    }
  }, {
    key: "conquestStatus",
    value: function conquestStatus() {
      var _this$game$state, _this$game$state2;
      if (this.conquestError) return this.conquestError;
      if (this.game.conquestRandom) return 'Resolving the battle with both players…';
      if ((_this$game$state = this.game.state) !== null && _this$game$state !== void 0 && _this$game$state.cardTransfer) return 'Collecting the defeated army’s cards…';
      if ((_this$game$state2 = this.game.state) !== null && _this$game$state2 !== void 0 && _this$game$state2.cardDraw) return 'Dealing your private territory card…';
      if (this.conquestSending) return 'Sending move…';
      return '';
    }
  }, {
    key: "initializeGame",
    value: function initializeGame() {
      var _this4 = this;
      if (!this.game.conquestInitialized) {
        var _this$game$options;
        this.initializeDice();
        this.game.conquestRevision = 0;
        this.game.conquestKnownHands = {};
        this.game.state = Engine.createGame({
          players: this.game.players.length,
          setup: ((_this$game$options = this.game.options) === null || _this$game$options === void 0 ? void 0 : _this$game$options.conquest_setup) === 'classic' ? 'classic' : 'quick',
          externalCards: true
        }, function (sides) {
          return _this4.rollDice(sides);
        });
        this.game.conquestInitialized = true;
        this.game.queue = this.game.queue || [];
        this.game.queue.push('CONQUEST_WAIT');
        this.game.queue.push('READY');
        this.game.queue.push("DECKANDENCRYPT\t1\t".concat(this.game.players.length, "\t").concat(JSON.stringify(Engine.cards)));
        this.saveGame(this.game.id);
      }
      this.game.target = this.game.state.currentPlayer;
      this.mountConquest();
    }

    /** Signatures bind commands to a game and a monotonically increasing revision. */
  }, {
    key: "signEnvelope",
    value: function () {
      var _signEnvelope = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(kind, data) {
        var payload, _t, _t2, _t3, _t4;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              payload = JSON.stringify(_objectSpread({
                kind: kind,
                game: this.game.id,
                revision: this.game.conquestRevision,
                player: this.game.player
              }, data));
              _t = payload;
              _t2 = this.app.crypto;
              _t3 = payload;
              _context3.n = 1;
              return this.app.wallet.getPrivateKey();
            case 1:
              _context3.n = 2;
              return _t2.signMessage.call(_t2, _t3, _context3.v);
            case 2:
              _t4 = _context3.v;
              return _context3.a(2, {
                payload: _t,
                signature: _t4
              });
          }
        }, _callee2, this);
      }));
      function signEnvelope(_x2, _x3) {
        return _signEnvelope.apply(this, arguments);
      }
      return signEnvelope;
    }()
  }, {
    key: "verifyEnvelope",
    value: function verifyEnvelope(envelope, kind) {
      if (!envelope || typeof envelope.payload !== 'string' || envelope.payload.length > 16000) throw Error('Invalid move envelope.');
      var data = JSON.parse(envelope.payload);
      if (data.kind !== kind || data.game !== this.game.id || data.revision !== this.game.conquestRevision || !Number.isInteger(data.player) || data.player < 1 || data.player > this.game.players.length || !this.app.crypto.verifyMessage(envelope.payload, envelope.signature, this.game.players[data.player - 1])) {
        throw Error('Invalid or stale move signature.');
      }
      return data;
    }
  }, {
    key: "broadcast",
    value: function () {
      var _broadcast = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(kind, data) {
        var envelope;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this.signEnvelope(kind, data);
            case 1:
              envelope = _context4.v;
              this.addMove("".concat(kind, "\t").concat(JSON.stringify(envelope)));
              _context4.n = 2;
              return this.endTurn(this.game.state.currentPlayer);
            case 2:
              return _context4.a(2);
          }
        }, _callee3, this);
      }));
      function broadcast(_x4, _x5) {
        return _broadcast.apply(this, arguments);
      }
      return broadcast;
    }()
  }, {
    key: "randomSecret",
    value: function randomSecret() {
      // generateKeys uses the wallet crypto implementation's secure random source.
      return this.app.crypto.hash(this.app.crypto.generateKeys());
    }
  }, {
    key: "needsRandom",
    value: function needsRandom(action) {
      return action.type === 'attack' || action.type === 'blitz';
    }
  }, {
    key: "validateAction",
    value: function validateAction(player, action) {
      if (player !== this.game.state.currentPlayer || !action || typeof action.type !== 'string') throw Error('It is not your turn.');
      if (this.game.state.cardDraw || this.game.state.cardTransfer) throw Error('Wait for the cards to finish.');
      // Validate against a clone, with a constant roll: this must not advance game.dice.
      var next = Engine.applyAction(this.game.state, _objectSpread(_objectSpread({}, action), {}, {
        player: player
      }), function () {
        return 1;
      });
      if (action.type === 'trade') {
        var _this$game$deck2;
        var ids = action.cards;
        var deck = (_this$game$deck2 = this.game.deck) === null || _this$game$deck2 === void 0 ? void 0 : _this$game$deck2[0];
        if (!Array.isArray(ids) || ids.some(function (id) {
          var _deck$discards;
          return !Engine.cards[id] || (deck === null || deck === void 0 || (_deck$discards = deck.discards) === null || _deck$discards === void 0 ? void 0 : _deck$discards[id]);
        })) throw Error('Those cards are not available.');
        var _loop2 = function _loop2() {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
            owner = _Object$entries$_i[0],
            known = _Object$entries$_i[1];
          if (Number(owner) !== player && ids.some(function (id) {
            return known.includes(id);
          })) throw Error('That card belongs to another player.');
        };
        for (var _i2 = 0, _Object$entries = Object.entries(this.game.conquestKnownHands || {}); _i2 < _Object$entries.length; _i2++) {
          _loop2();
        }
        if (player === this.game.player && ids.some(function (id) {
          return !(deck !== null && deck !== void 0 && deck.hand.includes(id));
        })) throw Error('You do not hold those cards.');
      }
      return next;
    }
  }, {
    key: "submitAction",
    value: function () {
      var _submitAction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(action) {
        var secret, _t5;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if (!(this.conquestSending || this.game.conquestRandom || this.game.over)) {
                _context5.n = 1;
                break;
              }
              throw Error('A move is already being resolved.');
            case 1:
              this.validateAction(this.game.player, action);
              this.conquestError = '';
              this.conquestSending = true;
              this.mountConquest();
              _context5.p = 2;
              if (!this.needsRandom(action)) {
                _context5.n = 4;
                break;
              }
              secret = this.randomSecret();
              this.game.conquestSecret = {
                revision: this.game.conquestRevision,
                secret: secret
              };
              this.saveGame(this.game.id); // Persist BEFORE sending, so reload can reveal.
              _context5.n = 3;
              return this.broadcast('CONQUEST_COMMIT', {
                action: action,
                commitment: this.app.crypto.hash(secret)
              });
            case 3:
              _context5.n = 5;
              break;
            case 4:
              _context5.n = 5;
              return this.broadcast('CONQUEST_ACTION', {
                action: action
              });
            case 5:
              _context5.n = 7;
              break;
            case 6:
              _context5.p = 6;
              _t5 = _context5.v;
              this.conquestSending = false;
              this.conquestError = _t5.message;
              this.mountConquest();
              throw _t5;
            case 7:
              return _context5.a(2);
          }
        }, _callee4, this, [[2, 6]]);
      }));
      function submitAction(_x6) {
        return _submitAction.apply(this, arguments);
      }
      return submitAction;
    }()
  }, {
    key: "randomPeer",
    value: function randomPeer(player, action) {
      var _this$game$state$terr, _this$game$state$play;
      var defender = (_this$game$state$terr = this.game.state.territories[action.to]) === null || _this$game$state$terr === void 0 ? void 0 : _this$game$state$terr.owner;
      if (defender > 0 && defender !== player) return defender;
      return (_this$game$state$play = this.game.state.players.find(function (p) {
        return p.id !== player && !p.eliminated;
      })) === null || _this$game$state$play === void 0 ? void 0 : _this$game$state$play.id;
    }
  }, {
    key: "servicePending",
    value: function () {
      var _servicePending = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var pending, key, _this$game$conquestEn, _key, _this$game$conquestSe, transfer, _key2;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              pending = this.game.conquestRandom;
              if (!pending) {
                _context6.n = 4;
                break;
              }
              if (!(!pending.entropy && this.game.player === pending.peer)) {
                _context6.n = 2;
                break;
              }
              key = "entropy:".concat(pending.id);
              if (this.responseSent.has(key)) {
                _context6.n = 1;
                break;
              }
              this.responseSent.add(key);
              this.game.conquestEntropy = ((_this$game$conquestEn = this.game.conquestEntropy) === null || _this$game$conquestEn === void 0 ? void 0 : _this$game$conquestEn.id) === pending.id ? this.game.conquestEntropy : {
                id: pending.id,
                value: this.randomSecret()
              };
              this.saveGame(this.game.id);
              _context6.n = 1;
              return this.broadcast('CONQUEST_ENTROPY', {
                id: pending.id,
                value: this.game.conquestEntropy.value
              });
            case 1:
              _context6.n = 4;
              break;
            case 2:
              if (!(pending.entropy && this.game.player === pending.player)) {
                _context6.n = 4;
                break;
              }
              _key = "reveal:".concat(pending.id);
              if (this.responseSent.has(_key)) {
                _context6.n = 4;
                break;
              }
              if (!(((_this$game$conquestSe = this.game.conquestSecret) === null || _this$game$conquestSe === void 0 ? void 0 : _this$game$conquestSe.revision) !== this.game.conquestRevision)) {
                _context6.n = 3;
                break;
              }
              throw Error('Battle secret missing. Restore this game from the device that sent the attack.');
            case 3:
              this.responseSent.add(_key);
              _context6.n = 4;
              return this.broadcast('CONQUEST_REVEAL', {
                id: pending.id,
                secret: this.game.conquestSecret.secret
              });
            case 4:
              transfer = this.game.state.cardTransfer;
              if (!(transfer && this.game.player === transfer.from)) {
                _context6.n = 5;
                break;
              }
              _key2 = "transfer:".concat(this.game.conquestRevision);
              if (this.responseSent.has(_key2)) {
                _context6.n = 5;
                break;
              }
              this.responseSent.add(_key2);
              _context6.n = 5;
              return this.broadcast('CONQUEST_TRANSFER', {
                cards: _toConsumableArray(this.game.deck[0].hand)
              });
            case 5:
              return _context6.a(2);
          }
        }, _callee5, this);
      }));
      function servicePending() {
        return _servicePending.apply(this, arguments);
      }
      return servicePending;
    }()
  }, {
    key: "applyAction",
    value: function () {
      var _applyAction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(player, action) {
        var _this5 = this,
          _next$cardTransfer,
          _this$conquestUI2;
        var next, deck, _iterator2, _step2, _loop3, draw, _deck, _t6;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              this.validateAction(player, action);
              next = Engine.applyAction(this.game.state, _objectSpread(_objectSpread({}, action), {}, {
                player: player
              }), function (sides) {
                return _this5.rollDice(sides);
              });
              if (!(action.type === 'trade')) {
                _context8.n = 7;
                break;
              }
              deck = this.game.deck[0];
              _iterator2 = _createForOfIteratorHelper(action.cards);
              _context8.p = 1;
              _loop3 = /*#__PURE__*/_regenerator().m(function _loop3() {
                var id, _i3, _Object$values, hand, i;
                return _regenerator().w(function (_context7) {
                  while (1) switch (_context7.n) {
                    case 0:
                      id = _step2.value;
                      deck.discards[id] = Engine.cards[id];
                      deck.hand = deck.hand.filter(function (card) {
                        return card !== id;
                      });
                      for (_i3 = 0, _Object$values = Object.values(_this5.game.conquestKnownHands); _i3 < _Object$values.length; _i3++) {
                        hand = _Object$values[_i3];
                        i = hand.indexOf(id);
                        if (i >= 0) hand.splice(i, 1);
                      }
                    case 1:
                      return _context7.a(2);
                  }
                }, _loop3);
              });
              _iterator2.s();
            case 2:
              if ((_step2 = _iterator2.n()).done) {
                _context8.n = 4;
                break;
              }
              return _context8.d(_regeneratorValues(_loop3()), 3);
            case 3:
              _context8.n = 2;
              break;
            case 4:
              _context8.n = 6;
              break;
            case 5:
              _context8.p = 5;
              _t6 = _context8.v;
              _iterator2.e(_t6);
            case 6:
              _context8.p = 6;
              _iterator2.f();
              return _context8.f(6);
            case 7:
              this.game.state = next;
              this.game.conquestRevision++;
              this.game.target = next.currentPlayer;
              this.conquestSending = false;
              this.conquestError = '';
              this.responseSent.clear();
              if (((_next$cardTransfer = next.cardTransfer) === null || _next$cardTransfer === void 0 ? void 0 : _next$cardTransfer.count) === 0) next.cardTransfer = null;
              if (next.cardDraw) {
                draw = next.cardDraw;
                _deck = this.game.deck[0];
                if (_deck.crypt.length + Object.keys(_deck.discards).length < draw.count) {
                  next.players.find(function (p) {
                    return p.id === draw.player;
                  }).cardCount -= draw.count;
                  next.cardDraw = null;
                } else {
                  this.game.queue.push('CONQUEST_DRAWN');
                  this.game.queue.push("SAFEDEAL\t1\t".concat(draw.player, "\t").concat(draw.count));
                }
              }
              this.saveGame(this.game.id);
              this.mountConquest();
              // Every client (including defenders and observers) finishes playback before
              // processing another queue action or opening the game-over overlay.
              _context8.n = 8;
              return (_this$conquestUI2 = this.conquestUI) === null || _this$conquestUI2 === void 0 ? void 0 : _this$conquestUI2.battlePlayback;
            case 8:
              if (!(next.winner && !this.game.over && !this.game.terminating)) {
                _context8.n = 9;
                break;
              }
              _context8.n = 9;
              return this.triggerGameOver([this.game.players[next.winner - 1]], 'world conquest');
            case 9:
              return _context8.a(2);
          }
        }, _callee6, this, [[1, 5, 6, 7]]);
      }));
      function applyAction(_x7, _x8) {
        return _applyAction.apply(this, arguments);
      }
      return applyAction;
    }()
  }, {
    key: "handleGameLoop",
    value: function () {
      var _handleGameLoop = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var command, _command$split, _command$split2, kind, json, envelope, data, pending, _pending, _t7, _t8;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              command = this.game.queue[this.game.queue.length - 1];
              if (command) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2, 0);
            case 1:
              _command$split = command.split('\t'), _command$split2 = _slicedToArray(_command$split, 2), kind = _command$split2[0], json = _command$split2[1];
              if (kind.startsWith('CONQUEST_')) {
                _context9.n = 2;
                break;
              }
              return _context9.a(2, 0);
            case 2:
              if (!(kind === 'CONQUEST_WAIT')) {
                _context9.n = 7;
                break;
              }
              this.game.target = this.game.state.currentPlayer;
              _context9.p = 3;
              _context9.n = 4;
              return this.servicePending();
            case 4:
              _context9.n = 6;
              break;
            case 5:
              _context9.p = 5;
              _t7 = _context9.v;
              this.conquestError = _t7.message;
            case 6:
              this.mountConquest();
              return _context9.a(2, 0);
            case 7:
              this.game.queue.pop();
              _context9.p = 8;
              if (!(kind === 'CONQUEST_DRAWN')) {
                _context9.n = 9;
                break;
              }
              this.game.state.cardDraw = null;
              this.conquestSending = false;
              _context9.n = 21;
              break;
            case 9:
              envelope = JSON.parse(json);
              data = this.verifyEnvelope(envelope, kind);
              if (!(kind === 'CONQUEST_ACTION')) {
                _context9.n = 12;
                break;
              }
              if (!(this.game.conquestRandom || this.needsRandom(data.action))) {
                _context9.n = 10;
                break;
              }
              throw Error('This move requires a committed battle roll.');
            case 10:
              _context9.n = 11;
              return this.applyAction(data.player, data.action);
            case 11:
              _context9.n = 21;
              break;
            case 12:
              if (!(kind === 'CONQUEST_COMMIT')) {
                _context9.n = 14;
                break;
              }
              if (!(this.game.conquestRandom || !this.needsRandom(data.action) || !/^[a-f0-9]{64}$/i.test(data.commitment))) {
                _context9.n = 13;
                break;
              }
              throw Error('Invalid battle commitment.');
            case 13:
              this.validateAction(data.player, data.action);
              this.game.conquestRandom = {
                id: this.app.crypto.hash(envelope.payload),
                player: data.player,
                peer: this.randomPeer(data.player, data.action),
                commitment: data.commitment,
                action: data.action
              };
              this.conquestSending = false;
              _context9.n = 21;
              break;
            case 14:
              if (!(kind === 'CONQUEST_ENTROPY')) {
                _context9.n = 16;
                break;
              }
              pending = this.game.conquestRandom;
              if (!(!pending || data.id !== pending.id || data.player !== pending.peer || pending.entropy || !/^[a-f0-9]{64}$/i.test(data.value))) {
                _context9.n = 15;
                break;
              }
              throw Error('Invalid battle contribution.');
            case 15:
              pending.entropy = data.value;
              _context9.n = 21;
              break;
            case 16:
              if (!(kind === 'CONQUEST_REVEAL')) {
                _context9.n = 19;
                break;
              }
              _pending = this.game.conquestRandom;
              if (!(!_pending || !_pending.entropy || data.id !== _pending.id || data.player !== _pending.player || typeof data.secret !== 'string' || this.app.crypto.hash(data.secret) !== _pending.commitment)) {
                _context9.n = 17;
                break;
              }
              throw Error('Invalid battle reveal.');
            case 17:
              this.game.dice = this.app.crypto.hash("".concat(this.game.id, ":").concat(_pending.id, ":").concat(data.secret, ":").concat(_pending.entropy));
              this.game.conquestRandom = null;
              delete this.game.conquestSecret;
              delete this.game.conquestEntropy;
              _context9.n = 18;
              return this.applyAction(data.player, _pending.action);
            case 18:
              _context9.n = 21;
              break;
            case 19:
              if (!(kind === 'CONQUEST_TRANSFER')) {
                _context9.n = 20;
                break;
              }
              this.acceptTransfer(data);
              _context9.n = 21;
              break;
            case 20:
              throw Error('Unknown Conquest command.');
            case 21:
              _context9.n = 23;
              break;
            case 22:
              _context9.p = 22;
              _t8 = _context9.v;
              this.conquestError = _t8.message;
              this.conquestSending = false;
              console.warn('Conquest rejected command:', _t8.message);
            case 23:
              this.saveGame(this.game.id);
              this.mountConquest();
              return _context9.a(2, 1);
          }
        }, _callee7, this, [[8, 22], [3, 5]]);
      }));
      function handleGameLoop() {
        return _handleGameLoop.apply(this, arguments);
      }
      return handleGameLoop;
    }()
  }, {
    key: "acceptTransfer",
    value: function acceptTransfer(data) {
      var transfer = this.game.state.cardTransfer;
      var deck = this.game.deck[0];
      if (!transfer || data.player !== transfer.from || !Array.isArray(data.cards) || data.cards.length !== transfer.count || new Set(data.cards).size !== data.cards.length || data.cards.some(function (id) {
        return !Engine.cards[id] || deck.discards[id];
      })) throw Error('Invalid captured hand.');
      var _loop4 = function _loop4() {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i4], 2),
          owner = _Object$entries2$_i[0],
          hand = _Object$entries2$_i[1];
        if (Number(owner) !== transfer.from && data.cards.some(function (id) {
          return hand.includes(id);
        })) throw Error('Captured hand contains another player’s cards.');
      };
      for (var _i4 = 0, _Object$entries2 = Object.entries(this.game.conquestKnownHands); _i4 < _Object$entries2.length; _i4++) {
        _loop4();
      }
      if (this.game.player === transfer.to) {
        var _deck$hand;
        if (data.cards.some(function (id) {
          return deck.hand.includes(id);
        })) throw Error('Captured hand duplicates your own cards.');
        (_deck$hand = deck.hand).push.apply(_deck$hand, _toConsumableArray(data.cards));
      }
      if (this.game.player === transfer.from) deck.hand = [];
      this.game.conquestKnownHands[transfer.to] = [].concat(_toConsumableArray(this.game.conquestKnownHands[transfer.to] || []), _toConsumableArray(data.cards));
      this.game.conquestKnownHands[transfer.from] = [];
      this.game.state.cardTransfer = null;
      this.responseSent.clear();
    }
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      expressapp.get('/conquest/demo', function (req, res) {
        return res.sendFile("".concat(__dirname, "/web/index.html"));
      });
      var _loop5 = function _loop5() {
        var file = _arr2[_i5];
        expressapp.get("/conquest/lib/".concat(file), function (req, res) {
          return res.sendFile("".concat(__dirname, "/lib/").concat(file));
        });
      };
      for (var _i5 = 0, _arr2 = ['map.js', 'engine.js']; _i5 < _arr2.length; _i5++) {
        _loop5();
      }
      _superPropGet(Conquest, "webServer", this, 3)([app, expressapp, express]);
    }
  }]);
}(GameTemplate);
module.exports = Conquest;